export function maskPhone(value) {
  return `${value.substr(0, 2)} (${value.substr(2, 3)}) ${value.substr(
    5,
    3
  )}-${value.substr(8)}`;
}
